module.exports = __webpack_public_path__ + "static/media/23(2).0eca5ef2.jpg";